import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import BreakerQuestionViewModel from '../../BreakerQuestionViewModel'

export default function BreakerValue({}: ValueComponentProps<BreakerQuestionViewModel>) {
  return <>(breaker)</>
}
